import { Col, Row } from "react-bootstrap";

export default function InputRadio({ label, items, name, register }) {
  return (
    <Row>
      <Col md={{ offset: 1, span: 4 }}>
        <label>{label}: </label>
      </Col>
      <Col md={6}>
        {items.map((item, index) => {
          return (
            <div key={index}>
              <label className="radio-container">
                {item.title}
                <input
                  type="radio"
                  name={name}
                  value={item.value}
                  defaultChecked = {item.value === "None" ? true : ""}
                  {...register(name)}
                />
                <span className="checkmark"></span>
              </label>
            </div>
          );
        })}
      </Col>
    </Row>
  );
}
